import React from 'react';
import Heading from '../heading/Heading';
import Manufacturer from '../common/Manufacturer';

const FabricInfo = ( { fabric } ) => {
    const buildSpec = fabricInfo => {
        const items = [];
        Object.keys(fabricInfo.specification.content).map(( label, index ) => {
            items.push(<li className='stolo-list-item' key={index}>
                <span className='stolo-list-item-label'>{label}: </span>
                <span className='stolo-list-item-value'>
                    {fabricInfo.specification.content[label]}
                </span>
            </li>);
        });
        return items;
    };

    const buildCareInstructions = fabricInfo => {
        const items = [];
        fabricInfo['care-instructions'].content.map(( value, index ) => {
            items.push(<li className='stolo-list-item' key={index}>
                <span className='stolo-list-item-value'>{value}</span>
            </li>);
        });
        return items;
    };

    const buildFabricInfo = () => {
        const fabricInfo = fabric;
        return (
            <React.Fragment>
                <div>
                    {fabricInfo.description.content}
                </div>
                <img
                    src={fabricInfo.description.img}
                    alt={fabricInfo.title}
                />
                <Heading level={2} text={fabricInfo.usage.label}/>
                <div>
                    {fabricInfo.usage.content}
                </div>
                <img
                    src={fabricInfo.usage.img}
                    alt={fabricInfo.usage.label}
                />
                <Heading
                    level={2}
                    text={fabricInfo.specification.label}
                />
                <div>
                    <ul>
                        {buildSpec(fabricInfo)}
                    </ul>
                </div>
                <Heading
                    level={2}
                    text={fabricInfo['care-instructions'].label}
                />
                <div>
                    <ul>
                        {buildCareInstructions(fabricInfo)}
                    </ul>
                    <img
                        src='https://d2k02hhj0n6fcf.cloudfront.net/images/care-1-2.png'
                        alt={fabricInfo['care-instructions'].label}
                    />
                </div>
                <Manufacturer />
            </React.Fragment>
        );
    };

    return (
        <div>
            {buildFabricInfo()}
        </div>
    );
};

export default FabricInfo;



// WEBPACK FOOTER //
// ./src/components/pattern/FabricDescription.js